export const setUserInfo = (info) =>{
    return{
        type:'SET_USER_INFO',
        value:info
    }
};

export const setUserAccessTocken = (token) =>{
    return{
        type:'SET_USER_TOKEN',
        value:token
    }
};

export const setUserSignFlag = (flag) =>{
    return{
        type:'SET_USER_SIGNIN',
        value:flag
    }
};